import React, { useEffect, useState } from "react";
import { FiMenu } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { NavItemType } from "../../../navigation";
import { Tooltip } from "@mui/material";
import {
  isCheckForNavigationPath,
  isCheckModuleForNavigationPath,
} from "src/helpers/userAccessFun";
import { useGetAllPendingRegistrationRequestQuery } from "src/services/RegistrationRequestServices";
import { BiSearch } from "react-icons/bi";
import { TbDeviceImac, TbHome, TbSettings } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { setIsCollapsed } from "src/redux/slices/SideNavLayoutSlice";
import { UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { LuLandmark } from "react-icons/lu";
import { LuUserCog } from "react-icons/lu";
import { FaRegPenToSquare } from "react-icons/fa6";
import { GiStairsGoal } from "react-icons/gi";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import { PiExamLight } from "react-icons/pi";

type Props = {
  toggleCollapse: () => void;
  isCollapsed: boolean;
  navigation: NavItemType[];
  isPathEqualtoNavItem?: (navItem: any) => boolean;
};

const categoryNavigation = [
  {
    label: "Home",
    parentPath: "",
    path: "/welcome",
    icon: TbHome,
  },
  {
    label: "Configuration",
    icon: TbSettings,
    parentPath: "configuration",
    path: "/configuration/modes",
    moduleName: UserModuleNameTypes.CONFIGURATION,
  },
  {
    label: "Finance",
    icon: HiOutlineCurrencyRupee,
    parentPath: "finance",
    moduleName: UserModuleNameTypes.FINANCE,
    path: "/finance/expense-categories",
  },
  {
    label: "Goal",
    icon: GiStairsGoal,
    parentPath: "goals",
    moduleName: UserModuleNameTypes.GOAL_CONFIGURATION,
    path: "/goals/goal-categories",
  },
  {
    label: "Registration",
    icon: FaRegPenToSquare,
    parentPath: "marketing",
    moduleName: UserModuleNameTypes.REGISTRATION,
    path: "/registration/registration-links",
  },
  {
    label: "Marketing",
    icon: LuLandmark,
    parentPath: "marketing",
    moduleName: UserModuleNameTypes.MARKETING,
    path: "/marketing/channel",
  },
  {
    label: "Users",
    icon: LuUserCog,
    parentPath: "marketing",
    moduleName: UserModuleNameTypes.MANAGEMENTSADMINS,
    path: "/admin/user",
  },
  {
    label: "Website",
    icon: TbDeviceImac,
    parentPath: "website-content",
    moduleName: UserModuleNameTypes.MANAGEMENTSADMINS,
    path: "/website-content/jobs",
  },
  {
    label: "Test Module",
    icon: PiExamLight,
    parentPath: "test-module",
    moduleName: UserModuleNameTypes.TEST_MODULE,
    path: "/test-module/category",
  },
];

const Badge = ({ value }: { value: string | number }) => {
  return (
    <div>
      <div className="bg-yellow-500 rounded-full text-[11px] font-medium text-white h-6 w-6 flex items-center justify-center">
        {value}
      </div>
    </div>
  );
};

const VerticalNavBar = ({
  toggleCollapse,
  isCollapsed,
  navigation,
  isPathEqualtoNavItem = () => false,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [pendingRequest, setPendingRequest] = useState<any>();

  const { data, isLoading, isFetching } =
    useGetAllPendingRegistrationRequestQuery("");

  const [searchQuery, setSearchQuery] = useState("");

  const filterNavItems = (navItem: NavItemType) => {
    return navItem.label.toLowerCase().includes(searchQuery.toLowerCase());
  };

  useEffect(() => {
    setPendingRequest(data?.data);
  }, [data, isLoading, isFetching]);

  const selectedCategorynavOptions = (path?: string) => {
    const seletedPath = location.pathname?.split("/")?.[1];
    const ModulePath = path?.split("/")?.[0];
    return seletedPath === ModulePath || "";
  };

  return (
    <div
      className={`h-full overflow-hidden bg-primary-light transition-all duration-500 border-r border-slate-300 md:static absolute z-[1]  ${isCollapsed
        ? "md:min-w-[0px] md:w-[0px] min-w-0 w-0"
        : "min-w-[300px] w-[300px]"
        }`}
    >
      {/* Logo & Menu Icon */}
      <div
        className={`flex px-4 items-center justify-between sticky top-0 py-3 h-[55px]`}
      >
        {/* Logo */}
        <div className={`font-semibold text-xl  ${isCollapsed && "md:hidden"}`}>
          Geeksdoor
        </div>

        {/* Menu Icon */}
        <Tooltip title="Alt + T">
          <button type="button" onClick={toggleCollapse} className="text-xl ">
            <FiMenu className="hidden md:block" />
            <MdCancel className="block text-xl md:hidden" />
          </button>
        </Tooltip>
      </div>

      {/* Navigations */}
      <div className="flex flex-col h-full overflow-hidden">
        <div className="relative border-y border-primary-dark">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={`bg-primary-light border-none rounded-md w-full text-sm font-regular focus:outline-none p-2 pl-10`}
          />
          <BiSearch className="absolute top-3 left-3" />
        </div>
        <div className="flex h-full overflow-hidden">
          {/* categoryNavigation */}
          <div className="flex flex-col h-full gap-4 p-3 bg-primary-dark">
            {categoryNavigation
              ?.filter((nav: any) => {
                return nav?.moduleName
                  ? isCheckForNavigationPath(nav?.moduleName)
                  : true;
              })
              ?.map((navItem: any, navIndex) => {
                return (
                  <Tooltip
                    key={navIndex}
                    title={navItem.label}
                    placement="right-end"
                  >
                    <div
                      onClick={() => {
                        dispatch(setIsCollapsed(false));
                        navItem.path &&
                          navigate(
                            isCheckModuleForNavigationPath(
                              navItem.moduleName,
                              navItem.path
                            )
                          );
                      }}
                      className={`flex items-center justify-center text-white rounded-md cursor-pointer aspect-square size-8 p-2 hover:bg-primary-main ${selectedCategorynavOptions(
                        navItem.path?.replace("/", "")
                      )
                        ? "bg-primary-main"
                        : ""
                        }`}
                    >
                      <navItem.icon />
                    </div>
                  </Tooltip>
                );
              })}
          </div>
          <div className="flex flex-col w-full gap-2 p-2 overflow-auto">
            {navigation
              ?.filter((module: any) => {
                return (
                  isCheckForNavigationPath(module.moduleName) &&
                  filterNavItems(module)
                );
              })
              .map((navItem, navIndex) => {
                return (
                  <div
                    key={navIndex}
                    onClick={() =>
                      navItem.path &&
                      navigate(
                        isCheckModuleForNavigationPath(
                          navItem.moduleName,
                          navItem.path
                        )
                      )
                    }
                    className={`
                flex
                gap-4
                items-center 
                py-[7px]
                px-3
                cursor-pointer 
                rounded
                ${!isPathEqualtoNavItem(navItem) && "hover:bg-primary-main"} 
                transition-all
                duration-300
               
                2xl:text-base md:text-body-1
                font-normal
                ${isPathEqualtoNavItem(navItem)
                        ? "bg-primary-main font-semibold"
                        : ""
                      } 
                `}
                  >
                    <div className="">
                      <navItem.icon />
                    </div>
                    <div
                      className={`flex justify-between  grow ${isCollapsed && " md:hidden"
                        }`}
                    >
                      {navItem.label}
                      {navItem?.badge &&
                        !isCollapsed &&
                        (isFetching || isLoading ? (
                          <div className="w-5 h-5 rounded-full bg-slate-300 animate-pulse"></div>
                        ) : (
                          <Badge value={pendingRequest} />
                        ))}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerticalNavBar;
